"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Facebook, Twitter, Linkedin, Instagram } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-2">
        <div className="h-4 w-20 bg-muted-light/20 animate-pulse rounded" />
        <div className="h-4 w-16 bg-muted-light/20 animate-pulse rounded" />
        <div className="h-4 w-24 bg-muted-light/20 animate-pulse rounded" />
      </div>;
  }
  return <nav className="flex flex-col gap-2">
      {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} data-index={i} className="text-sm text-foreground hover:text-secondary-dark transition-colors duration-[var(--duration-fast)]">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const socialLinks = [{
    icon: Facebook,
    href: "https://facebook.com",
    label: "Facebook"
  }, {
    icon: Twitter,
    href: "https://twitter.com",
    label: "Twitter"
  }, {
    icon: Linkedin,
    href: "https://linkedin.com",
    label: "LinkedIn"
  }, {
    icon: Instagram,
    href: "https://instagram.com",
    label: "Instagram"
  }];
  return <footer className="w-full bg-dark-background text-foreground-dark py-12 px-6">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
        {}
        <div className="flex flex-col gap-2">
          <p className="text-sm text-foreground">
            © {currentYear} FIRST CLASS RESOURCES, LLC
          </p>
          <p className="text-xs text-foreground">
            All rights reserved.
          </p>
        </div>

        {}
        <div className="flex flex-col gap-3">
          <h3 className="text-base font-display font-semibold text-foreground mb-1">
            Quick Links
          </h3>
          <MenuProvider menu_id="29">
            <FooterMenuConsumer />
          </MenuProvider>
        </div>

        {}
        <div className="flex flex-col gap-3 md:items-end">
          <h3 className="text-base font-display font-semibold text-foreground mb-1">
            Connect With Us
          </h3>
          <div className="flex gap-4">
            {socialLinks.map((social, i) => <Link key={social.label} to={social.href} data-index={i} newTab className="w-10 h-10 rounded-md bg-primary/20 flex items-center justify-center text-foreground-dark hover:bg-primary-hover hover:text-foreground-primary hover:-translate-y-1 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] shadow-soft hover:shadow-medium" aria-label={social.label}>
                <social.icon className="size-5" />
              </Link>)}
          </div>
        </div>
      </div>
    </footer>;
}